import { SvgProps } from "types/layout-types"

export const SvgTick = ({ className, onClick }: SvgProps) => {
    return (
        <>
            <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8"  stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    )
}